export function getImageFiles(files) {
  return Array.from(files || []).filter((file) => file?.type?.startsWith('image/'));
}

export function getClipboardImageFiles(event) {
  const clipboardData = event?.clipboardData;
  if (!clipboardData) return [];

  const directFiles = getImageFiles(clipboardData.files);
  if (directFiles.length > 0) return directFiles;

  return Array.from(clipboardData.items || [])
    .filter((item) => item?.kind === 'file' && item.type?.startsWith('image/'))
    .map((item) => item.getAsFile())
    .filter(Boolean);
}

export function readImageFilesAsDataUrls(files) {
  return Promise.all(
    getImageFiles(files).map((file) => (
      new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (event) => resolve(event.target?.result || null);
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(file);
      })
    ))
  ).then((images) => images.filter(Boolean));
}
